import React, { Component } from 'react';

import AuthLayout from '../../components/AuthLayout';
import { Login } from './Login';
import './index.css';
import ForgotPassword from './ForgotPassword';
import NewPassword from './NewPassword';

export default class index extends Component {
  state = {
    option: 0,
  };

  componentDidMount() {
    this.checkURL();
  }

  checkURL() {
    const params = new URLSearchParams(this.props.location.search); // classe para pegar queryString da URL
    const token = params.get('token');
    let forgotPassword = this.props.location?.state?.forgotPassword;

    if (token) {
      this.setState({ option: 2 });
    }

    if (forgotPassword) {
      this.setState({ option: 1 });
    }
  }

  renderOption(option) {
    switch (option) {
      case 0:
        return <Login handleOption={this.handleOption} />;
      case 1:
        return (
          <ForgotPassword
            handleOption={this.handleOption}
            history={this.props.history}
          />
        );
      case 2:
        return (
          <NewPassword
            handleOption={this.handleOption}
            history={this.props.history}
            location={this.props.location}
          />
        );
      default:
        return <Login handleOption={this.handleOption} />;
    }
  }

  handleOption = (option) => {
    this.setState({ option });
  };

  render() {
    const { option } = this.state;
    return (
      <AuthLayout
        eyebrow="Minha garagem"
        title="A história do seu veículo,"
        highlight="sempre com você."
      >
        {this.renderOption(option)}
      </AuthLayout>
    );
  }
}
